import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getEventos, registrarTapEvento  } from "../api";
import "../assets/css/style.css";
import { motion } from "framer-motion";

const Eventos = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categorias, setCategorias] = useState([]);
  const [categoriaActiva, setCategoriaActiva] = useState("all");
  const navigate = useNavigate();

  const formatearFecha = (fechaStr) => {
    const fecha = new Date(fechaStr);
    const opciones = { day: "2-digit", month: "short", year: "numeric" };
    const fechaFormateada = fecha.toLocaleDateString("es-ES", opciones);
    const partes = fechaFormateada.split(" ");
    const dia = partes[0];
    const mes = partes[1].charAt(0).toUpperCase() + partes[1].slice(1);
    const anio = partes[2];
    return dia + " " + mes + ", " + anio;
  };

  const formatearHoraExacta = (fechaStr) => {
    if (!fechaStr || typeof fechaStr !== "string") return "Hora inválida";
    var horaTxt = "";
    if (fechaStr.indexOf("T") !== -1) {
      horaTxt = fechaStr.split("T")[1].split(":");
    } else if (fechaStr.indexOf(" ") !== -1) {
      horaTxt = fechaStr.split(" ")[1].split(":");
    }
    if (!horaTxt || horaTxt.length < 2) return "Hora inválida";
    const h = Number(horaTxt[0]);
    const m = Number(horaTxt[1]);
    if (isNaN(h) || isNaN(m)) return "Hora inválida";
    const offset = -4;
    const horaLocal = (h + offset + 24) % 24;
    const ampm = horaLocal >= 12 ? "PM" : "AM";
    const hora12 = horaLocal % 12 === 0 ? 12 : horaLocal % 12;
    const minutos = m.toString().padStart(2, "0");
    return hora12 + ":" + minutos + " " + ampm;
  };

  useEffect(function () {
    async function cargarEventos() {
      try {
        const res = await getEventos();
        const eventosData = res && res.eventos ? res.eventos : [];
        const categoriasData = res && res.categorias ? res.categorias : [];
        setEventos(eventosData);
        var cats = [{ id: "all", nombre: "Todos" }].concat(categoriasData);
        setCategorias(cats);
        setCategoriaActiva("all");
      } catch (e) {
        console.error("Error cargando eventos:", e);
      } finally {
        setTimeout(function () {
          setLoading(false);
          document.body.style.overflow = "auto";
          window.scrollTo(0, 0);
        }, 3000);
      }
    }
    cargarEventos();
  }, []);

  const eventosFiltrados =
    categoriaActiva === "all"
      ? eventos
      : eventos.filter(function (e) {
          return String(e.id_categoria) === String(categoriaActiva);
        });

  return (
    <>
      {loading && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!loading && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
        >
          <div className="app-container">
            <div className="connections-container">
              <div className="back-container">
                <button className="back-btn" onClick={function () { navigate("/home"); }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                    <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
                  </svg>
                </button>
              </div>
              <h2 className="connections-title">Eventos</h2>
            </div>

            <div className="destinos-list eventos-list">
              <div className="filtro-categorias-wrap">
                <div className="filtro-categorias-scroll">
                  {categorias.map(function (cat) {
                    if (cat.id !== "all") {
                      var tieneEventos = eventos.some(function (e) {
                        return String(e.id_categoria) === String(cat.id);
                      });
                      if (!tieneEventos) return null;
                    }
                    var activa = String(categoriaActiva) === String(cat.id);
                    return (
                      <button
                        key={cat.id}
                        className={"filtro-chip " + (activa ? "activo" : "")}
                        onClick={function () { setCategoriaActiva(cat.id); }}
                        type="button"
                      >
                        <span className="filtro-nombre">{cat.nombre}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              {eventosFiltrados.length > 0 ? (
                eventosFiltrados.map(function (evento) {
                  return (
                    <div className="card-e" key={evento.id_evento}>
                      <div
                        className="evento-card-v2"
                        onClick={function () {
                          try {
                            registrarTapEvento(evento.id_evento, {
                              id_perfil: null,
                            });
                          } catch (e) {}

                          navigate("/evento/" + evento.id_evento);
                        }}
                      >
                        <img src={evento.portada} alt={evento.titulo} className="evento-imagen" />
                        <div className="badge-evento">{evento.organizador}</div>
                      </div>
                      <div className="evento-o">
                        <div className="evento -texto-v2">
                          <h3 className="titulo-e">{evento.titulo}</h3>
                          <p className="evento-d">
                            <svg width="15" height="15" viewBox="0 0 24 24">
                              <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                                <path d="M12.56 20.82a.96.96 0 0 1-1.12 0C6.611 17.378 1.486 10.298 6.667 5.182A7.6 7.6 0 0 1 12 3c2 0 3.919.785 5.333 2.181c5.181 5.116.056 12.196-4.773 15.64"></path>
                                <path d="M12 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"></path>
                              </g>
                            </svg>
                            {evento.lugar}.
                          </p>
                        </div>
                        <div className="evento-footer">
                          <div className="evento-fecha">
                            <span>{formatearFecha(evento.fecha)}</span> • <span>{formatearHoraExacta(evento.fecha)}</span>
                          </div>
                          <div className={"evento-precio" + (evento.tipo === 0 ? "" : " pago")}>
                            {evento.tipo === 0 ? "Gratis" : "De paga"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div style={{ marginBottom: 70, marginTop: 80, paddingRight: 15, paddingLeft: 15, textAlign: "center" }}>
                  <img src="/assets/images/empty.svg" style={{ width: 135, paddingBottom: 10 }} alt="Sin historial" />
                  <p>Aún no hay eventos programados, vuelve pronto.</p>
                </div>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Eventos;
